import { AsistenteEnLineaComponent } from './asistente-en-linea/asistente-en-linea.component';
import { Routes, RouterModule } from '@angular/router';
import { AsistenciaChatComponent } from './asistente-en-linea/components/asistencia-chat/asistencia-chat.component';
import { AsistenciaMailComponent } from './asistente-en-linea/components/asistencia-mail/asistencia-mail.component';
import { NgModule } from '@angular/core';




 const routes: Routes = [
    { path: '', component: AsistenteEnLineaComponent, pathMatch: 'full' },
    { path: 'chat', component: AsistenciaChatComponent },
    { path: 'mail', component: AsistenciaMailComponent},
    { path: 'config', loadChildren:()=> import('./config/config.module').then(mod => mod.ConfigModule)},
    { path: 'login', loadChildren:()=> import('./config/auth/auth.module').then(mod => mod.AuthModule)},
    
    

];

@NgModule({
    declarations:[],
    imports:[
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
})
export class AppRoutingModule { }
export const appRoutingProviders: any[] = [

];

